import {createUseStyles} from 'react-jss';
import Spacing from '../../../style-helper/Spacing';

export default createUseStyles({
  collectionAddressee: {
    marginTop: [Spacing.quad],
  },
  
  collectionHelpLabel: {
    fontSize: 14,
    color: '#383838',
  },
});
